import api from '@/api/axios';

const state = {
  insightlist: [],
  insightDetail: null, // 개별 상세 데이터를 저장할 상태 추가
  qaComment: null,
  isLoading: false,
  error: null,
};

const mutations = {
  SET_INSIGHTLIST(state, insightlist) {
    state.insightlist = insightlist;
  },
  SET_INSIGHTLIST_DETAIL(state, insightDetail) {
    state.insightDetail = insightDetail;
  },
  SET_QA_COMMENT(state, qaComment) {
    state.qaComment = qaComment;
  },
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  ADD_INSIGHTLIST(state, insightlist) {
    state.insightlist.push(insightlist);
  },
  ADD_QA_COMMENT(state, qaComment) {
    state.qalist.push(qaComment);
  },
  REMOVE_INSIGHT_BY_ID(state, insightId) {
    state.insightlist = state.insightlist.filter(item => String(item.insight_id) !== String(insightId));
  },
  CLEAR_INSIGHT_DETAIL(state) {
    state.insightDetail = null;
  },
};

const actions = {
  // 전체 Insight 목록 가져오기
  async fetchInsightList({ commit, rootState }) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const token = rootState.auth.token;
      if (!token) {
        throw new Error('No authentication token found');
      }
      const response = await api.get(`/api/v1/communication/insight_list`);
      console.log('response', response.data);
      commit('SET_INSIGHTLIST', response.data);
    } catch (error) {
      console.error('Failed to fetch Insight list:', error);
      if (error.response && error.response.status === 401) {
        commit('auth/SET_TOKEN', null, { root: true });
        commit('auth/SET_USER', null, { root: true });
        return 'INVALID_TOKEN';
      }
      commit('SET_ERROR', error.message || 'Failed to fetch insight list');
    } finally {
      commit('SET_LOADING', false);
    }
  },

  // 특정 Insight 상세 조회
  async fetchInsightDetail({ commit, rootState }, insight_id) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const token = rootState.auth.token;
      if (!token) {
        throw new Error('No authentication token found');
      }
      const response = await api.get(`/api/v1/communication/insight_detail/${insight_id}`);
      console.log(`Insight Detail (insight_id: ${insight_id})`, response.data);
      commit('SET_INSIGHTLIST_DETAIL', response.data);
    } catch (error) {
      console.error(`Failed to fetch Insight detail (insight_id: ${insight_id}):`, error);
      if (error.response && error.response.status === 401) {
        commit('auth/SET_TOKEN', null, { root: true });
        commit('auth/SET_USER', null, { root: true });
        return 'INVALID_TOKEN';
      }
      commit('SET_ERROR', error.message || `Failed to fetch insight detail (insight_id: ${insight_id})`);
    } finally {
      commit('SET_LOADING', false);
    }
  }, 
  // Insight 생성하기
  async createInsightList({ commit, rootState }, insightListData) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const token = rootState.auth.token;
      if (!token) {
        throw new Error('No authentication token found');
      }
      console.log(insightListData);
      const response = await api.post(`/api/v1/communication/saveInsightList`, insightListData);
      commit('ADD_QALIST', response.data);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Failed to create Insight:', error);
      if (error.response) {
        console.error('Error response:', error.response.data);
        commit('SET_ERROR', `Failed to create Insight: ${JSON.stringify(error.response.data)}`);
      } else {
        commit('SET_ERROR', error.message || 'Failed to create Insight');
      }
      return {
        success: false,
        error: error.response ? error.response.data : (error.message || 'Failed to create Insight')
      };
    } finally {
      commit('SET_LOADING', false);
    }
  }, 


  // 특정 QA comment 조회
  async fetchQaComment({ commit, rootState }, qa_id) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const token = rootState.auth.token;
      if (!token) {
        throw new Error('No authentication token found');
      }
      const response = await api.get(`/api/v1/communication/qa_comment/${qa_id}`);
      console.log(`QA Detail (qa_id: ${qa_id})`, response.data);
      commit('SET_QA_COMMENT', response.data);
    } catch (error) {
      console.error(`Failed to fetch QA detail (qa_id: ${qa_id}):`, error);
      if (error.response && error.response.status === 401) {
        commit('auth/SET_TOKEN', null, { root: true });
        commit('auth/SET_USER', null, { root: true });
        return 'INVALID_TOKEN';
      }
      commit('SET_ERROR', error.message || `Failed to fetch QA detail (qa_id: ${qa_id})`);
    } finally {
      commit('SET_LOADING', false);
    }
  },
  
  // 관리자 답변 생성
  async createQaComment({ commit, rootState }, qaCommentData) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const token = rootState.auth.token;
      if (!token) {
        throw new Error('No authentication token found');
      }
      console.log(qaCommentData);
      const response = await api.post(`/api/v1/communication/saveQaComment`, qaCommentData);
      commit('ADD_QA_COMMENT', response.data);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Failed to create QA:', error);
      if (error.response) {
        console.error('Error response:', error.response.data);
        commit('SET_ERROR', `Failed to create QA: ${JSON.stringify(error.response.data)}`);
      } else {
        commit('SET_ERROR', error.message || 'Failed to create QA');
      }
      return {
        success: false,
        error: error.response ? error.response.data : (error.message || 'Failed to create QA')
      };
    } finally {
      commit('SET_LOADING', false);
    }
  },

  // Insight 삭제
  async deleteInsight({ commit, rootState }, insight_id) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const token = rootState.auth.token;
      if (!token) {
        throw new Error('No authentication token found');
      }

      // 서버 API 경로는 실제 백엔드 규칙에 맞게 수정하세요.
      // 일반적으로 DELETE 메서드 사용: /api/v1/communication/insight/{id}
      await api.delete(`/api/v1/communication/insight/${insight_id}`);

      // 로컬 상태 정리
      commit('REMOVE_INSIGHT_BY_ID', insight_id);
      commit('CLEAR_INSIGHT_DETAIL');

      return { success: true };
    } catch (error) {
      console.error(`Failed to delete Insight (insight_id: ${insight_id}):`, error);

      if (error.response && error.response.status === 401) {
        commit('auth/SET_TOKEN', null, { root: true });
        commit('auth/SET_USER', null, { root: true });
        return 'INVALID_TOKEN';
      }

      // 서버가 메시지를 주면 그대로, 아니면 일반 메시지
      const msg = error.response?.data
        ? (typeof error.response.data === 'string' ? error.response.data
           : JSON.stringify(error.response.data))
        : (error.message || `Failed to delete insight (insight_id: ${insight_id})`);

      commit('SET_ERROR', msg);
      return { success: false, error: msg };
    } finally {
      commit('SET_LOADING', false);
    }
  },


};

const getters = {
  allInsightlistlist: state => state.insightlist,
  insightDetail: state => state.insightDetail, // QA 상세 정보 가져오는 게터 추가
  qaComment: state => state.qaComment, 
  isLoading: state => state.isLoading,
  error: state => state.error,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
